import { connect } from 'react-redux';
import {
  loadCourseAssemblage,
  getCourseAssemblageStatus,
  getPrevAndNextQuestionSetIds,
} from 'edrolo/domains/bySchoolClass';

import PrevNextLinks from './PrevNextLinks';

const mapStateToProps = (state, { classId, questionSetId }) => {
  const prevAndNextIds = getPrevAndNextQuestionSetIds(
    state,
    classId,
    questionSetId
  );
  return {
    assemblageStatus: getCourseAssemblageStatus(state, classId),
    prevQuestionSetId: prevAndNextIds.get('prevQuestionSetId', null),
    nextQuestionSetId: prevAndNextIds.get('nextQuestionSetId', null),
  };
};

const mapDispatchToProps = (dispatch) => ({
  loadAssemblage: (classId) => dispatch(loadCourseAssemblage.signal(classId)),
});

export default connect(mapStateToProps, mapDispatchToProps)(PrevNextLinks);
